import { useNavigate, useLocation } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const SignupSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailPreApproved = location.state?.emailPreApproved ?? false;

  const handleClose = () => {
    navigate('/login');
  };

  return (
    <div className="signup-success-container">
      <button className="close-btn" onClick={handleClose}>
        <FaTimes />
      </button>
      <h2>Signup Successful</h2>
      <div className="success-message">
        {emailPreApproved
          ? <p>Please confirm your email.</p>
          : <p>Upon confirming your email, collect the one-time reference code from support.</p>
        }
      </div>

      <style>{`
        .signup-success-container {
          max-width: 600px;
          margin: 2rem auto;
          padding: 2rem;
          background: rgba(255, 255, 255, 0.9); /* Slightly transparent */
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          text-align: center;
        }
        .close-btn {
          float: right;
          background: none;
          border: none;
          cursor: pointer;
          color: #666;
          font-size: 1.2rem;
        }
        .close-btn:hover {
          color: #333;
        }
        h2 {
          color: #333;
          margin-bottom: 1.5rem;
        }
        .success-message {
          background: #d4edda;
          color: #155724;
          padding: 1rem;
          border-radius: 4px;
          margin: 1rem 0;
          font-size: 0.9rem;
          border: 1px solid #c3e6cb;
        }
        @media (max-width: 600px) {
          .signup-success-container {
            margin: 1rem;
            padding: 1rem;
          }
        }
        html[data-theme="dark"] .signup-success-container {
          background: #1e1e1e;
          box-shadow: 0 2px 10px rgba(0,0,0,0.4);
        }
        html[data-theme="dark"] .close-btn {
          color: #aaa;
        }
        html[data-theme="dark"] .close-btn:hover {
          color: #fff;
        }
        html[data-theme="dark"] h2 {
          color: #f0f0f0;
        }
        html[data-theme="dark"] .success-message {
          background: #1a3a23;
          color: #7ee8a2;
          border-color: #2d6a3f;
        }
      `}</style>
    </div>
  );
};

export default SignupSuccess;